import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstantsService } from '../constants/app-constants.service';
// const AUTH_API = 'https://erpapi.foodjunctionstore.com/v1/auth/generate-token';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', tenant_name: 'foodjunctionstore' })
};
@Injectable({
    providedIn: 'root'
})
export class AuthService {
    authApi: any;
    constructor(private http: HttpClient, public appConstant: AppConstantsService) {
        let url = 'auth/generate-token'
        this.authApi = this.appConstant.HOME_URL + url;
    }
    // login, register
    refreshToken(token: string) {
        console.log(token);
        let user = JSON.parse(localStorage.getItem("agGrocery") || "{}");
        if (user) {
            return this.http.post(this.authApi, {
                refreshToken: token,
                deviceUniqueId: user.deviceUniqueId
            }, httpOptions);
        }
    }
}